import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const PinCountyIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M4 2C3.448 2 3 2.448 3 3C3 3.552 3.448 4 4 4H7.10547C6.51972 4.57347 6.03996 5.25119 5.68359 6H4C3.448 6 3 6.448 3 7C3 7.552 3.448 8 4 8H5.08008C5.03304 8.32769 5 8.6593 5 9C5 9.31887 5.03653 9.6559 5.08984 10H4C3.448 10 3 10.448 3 11C3 11.552 3.448 12 4 12H5.61719C5.85038 12.6572 6.1375 13.3278 6.46289 14H4C3.448 14 3 14.448 3 15C3 15.552 3.448 16 4 16H7.53125C8.98828 18.5142 10.6848 20.7621 11.5059 21.7578C11.7629 22.0698 12.2352 22.0698 12.4922 21.7578C14.0872 19.8248 19 13.188 19 9C19 5.134 15.866 2 12 2H4ZM12 7C13.105 7 14 7.895 14 9C14 10.105 13.105 11 12 11C10.895 11 10 10.105 10 9C10 7.895 10.895 7 12 7Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

PinCountyIcon.propTypes = {
  sx: PropTypes.object,
};

export default PinCountyIcon;
